import { graphql, useStaticQuery } from 'gatsby'

import { MiddleBanner } from '@components/MiddleBanner'

export const GettingStartedBanner = () => {
  const { GettingStartedBannerQuery } = useStaticQuery(graphql`
    query GettingStartedBannerQuery {
      GettingStartedBannerQuery: sanitySectionGetStarted(
        _id: { eq: "f2bb4eb1-2af1-4b6c-adfc-ab52e9652a49" }
      ) {
        _rawGetStarted
      }
    }
  `)
  return <MiddleBanner {...GettingStartedBannerQuery._rawGetStarted} />
}
